import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Helmet from 'react-helmet';

import PressLogos from './PressLogos';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const Wrapper = ({ children, className }) => {
  const classes = classNames({
    'signup-layout-wrapper': true,
    [className]: !!className,
  });

  return (
    <Fragment>
      <Helmet>
        <body className="body-signup" />
      </Helmet>

      <div className={classes}>
        {children}
        <PressLogos />
      </div>
    </Fragment>
  );
};

Wrapper.propTypes = propTypes;

export default Wrapper;
